export const Alarm = ({ className = '' }: { className?: string }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.84403 1.6026C9.06356 1.95386 8.95678 2.41657 8.60553 2.6361L4.60551 5.1361C4.25425 5.35563 3.79154 5.24885 3.57201 4.8976C3.35248 4.54634 3.45926 4.08363 3.81051 3.8641L7.81053 1.3641C8.16179 1.14457 8.6245 1.25135 8.84403 1.6026ZM16.572 1.6026C16.7915 1.25135 17.2543 1.14457 17.6055 1.3641L21.6055 3.8641C21.9568 4.08363 22.0635 4.54635 21.844 4.8976C21.6245 5.24885 21.1618 5.35563 20.8105 5.1361L16.8105 2.6361C16.4593 2.41657 16.3525 1.95385 16.572 1.6026ZM12.708 4.7501C8.15166 4.7501 4.45801 8.44375 4.45801 13.0001C4.45801 17.5564 8.15166 21.2501 12.708 21.2501C17.2644 21.2501 20.958 17.5564 20.958 13.0001C20.958 8.44375 17.2644 4.7501 12.708 4.7501ZM2.95801 13.0001C2.95801 7.61532 7.32323 3.2501 12.708 3.2501C18.0928 3.2501 22.458 7.61532 22.458 13.0001C22.458 18.3849 18.0928 22.7501 12.708 22.7501C7.32323 22.7501 2.95801 18.3849 2.95801 13.0001ZM12.708 8.2501C13.1222 8.2501 13.458 8.58589 13.458 9.0001V12.6894L15.7383 14.9698C16.0312 15.2627 16.0312 15.7375 15.7383 16.0304C15.4454 16.3233 14.9706 16.3233 14.6777 16.0304L12.1777 13.5304C12.037 13.3898 11.958 13.199 11.958 13.0001V9.0001C11.958 8.58589 12.2938 8.2501 12.708 8.2501Z"
        fill="currentColor"
      />
    </svg>
  )
}
